import { observable, action } from 'mobx'
import { IStaffInfo } from '@/model/types/staff'

export default class StaffStore {
    @observable
    public staffInfo: IStaffInfo | null = null

    @action
    public setStaffInfo(staffInfo: IStaffInfo) {
        this.staffInfo = staffInfo
    }

    public canIUse(perssion: number) {
        if (!this.staffInfo) return false
        if (perssion === 0 || this.staffInfo.permission_list == null) return true

        return this.staffInfo.permission_list.includes(perssion)
    }
}

export const staffStore = new StaffStore()
